var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 35"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 209"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 39",
    cx: 8,
    cy: 5,
    r: 4.5,
    fill: "#A5A5A5",
    stroke: "#626262"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 40",
    cx: 8,
    cy: 5,
    r: 2,
    fill: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1443",
    x: 7,
    y: 7,
    width: 2,
    height: 3,
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1444",
    x: 6,
    y: 9,
    width: 1,
    height: 5,
    fill: "#626262"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1448",
    x: 6,
    y: 15,
    width: 1,
    height: 4,
    transform: "rotate(-90 6 15)",
    fill: "#626262"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1445",
    x: 9,
    y: 9,
    width: 1,
    height: 5,
    fill: "#626262"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1446",
    x: 7,
    y: 10,
    width: 2,
    height: 1,
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1447",
    x: 7,
    y: 11,
    width: 2,
    height: 3,
    fill: "url(#paint0_linear_44_1327)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_44_1327",
    x1: 7,
    y1: 12.5,
    x2: 9,
    y2: 12.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#949494"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHide);
export default __webpack_public_path__ + "static/media/hide.04a01901cafbe9b128a40ac8699d2319.svg";
export { ForwardRef as ReactComponent };